import { DollarCircleOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

function UnstractPricingMenuLink({ orgName }) {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(`/${orgName}/pricing`)}
      className="logout-button"
    >
      <DollarCircleOutlined /> Pricing
    </Button>
  );
}

UnstractPricingMenuLink.propTypes = {
  orgName: PropTypes.string.isRequired,
};

export { UnstractPricingMenuLink };
